import React, { useContext } from "react";

import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";
import { round } from "@/utils/number";

import MealPlanFormStore from "../store/MealPlanFormStore";

const useStyles = makeStyles()({
  macronutrientText: {
    color: colors.dark,
    fontWeight: 600,
    marginLeft: "5px",
  },
});

const MacronutrientsGuide: React.FC = observer(() => {
  const { classes } = useStyles();

  const store = useContext(MealPlanFormStore.Context);
  const macronutrients = store.macronutrients;

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap">
      <Box display="flex" flexDirection="row" marginRight="14px">
        <Typography variant="subtitle1" color="textSecondary">
          Carbohydrates:
        </Typography>
        <Typography variant="subtitle1" className={classes.macronutrientText}>
          {macronutrients.carbohydrates} % |{" "}
          {round(macronutrients.carbohydrateGrams, 2)}g
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row" marginRight="14px">
        <Typography variant="subtitle1" color="textSecondary">
          Proteins:
        </Typography>
        <Typography variant="subtitle1" className={classes.macronutrientText}>
          {macronutrients.proteins} % | {round(macronutrients.proteinGrams, 2)}g
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row" marginRight="14px">
        <Typography variant="subtitle1" color="textSecondary">
          Fats:
        </Typography>
        <Typography variant="subtitle1" className={classes.macronutrientText}>
          {macronutrients.fats} % | {round(macronutrients.fatGrams, 2)}g
        </Typography>
      </Box>
    </Box>
  );
});

export default MacronutrientsGuide;
